

















































import Vue from 'vue'
import request from '@/utils/request'
export default Vue.extend({
    data() {
        return {
            id: '',
            realName: '',
            phone: '',
            state: 0, //  0：已取消 1：待关联 2：已关联 3: 驳回
            type: '', // 1:水库员 2:信息员
            refuseTxt: '',
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            request.get('/api/account/rest_manager_apply').then((res: any) => {
                if (!res || !res.id) {return}
                const { id, realName, phone, type, refuseTxt, state } = res
                this.id = id
                this.realName = realName
                this.phone = phone
                this.state = state
                this.type = String(type)
                this.refuseTxt = refuseTxt
            })
        },
        submit() {
            if (!this.realName) {return this.$Message.warning('姓名不能为空')}
            if (!this.phone) {return this.$Message.warning('手机号不能为空')}
            if (!/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(this.phone)) {return this.$Message.warning('手机号格式不正确')}
            if (!this.type) {return this.$Message.warning('角色不能为空')}
            const { id, realName, phone, type } = this
            request.get(`/api/farming/rest_rel/role_type`, {phone}).then((data) => {
                // console.log(data)
                if (data === 1 && type === '2') {
                    return this.$Message.warning('申请手机号不存在')
                } else if (data === 2 && type === '1') {
                    return this.$Message.warning('申请手机号不存在')
                }
                const params = { realName, phone, type: Number(type) }
                if (data === 3) {
                    params.type = 3
                }
                // console.log(params)
                const url = '/api/farming/rest_rel'
                if (id) {
                    request.put(url, params)
                    .then(() => this.getData())
                    .catch((err) => this.$Message.warning(err))
                } else {
                    request.post(url, params)
                    .then(() => this.getData())
                    .catch((err) => this.$Message.warning(err))
                }
            })
        },
        blurRealName() {
            // if (!this.realName) return this.$Message.warning('姓名不能为空')
        },
        blurPhone() {
            // if (!this.phone) return this.$Message.warning('手机号不能为空')
            // if (!/^(1[3456789]\d{9})$/.test(this.phone)) return this.$Message.warning('手机号格式不正确')
        },
    },
})
